import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import MasterFSPMaintenanceCont from "presentation/view/container/MasterFSP/MasterFSPContMain";

CommonEntrypoint(<MasterFSPMaintenanceCont/>)